import type { AssistantMode } from '../../lib/harry/assistantMode';
import { ConciergeHelperIcon, ConciergeHelperHeaderIcon } from './ConciergeHelperIcon';
import { HarryIcon } from './HarryIcon';
import { HarryHeaderIcon } from './HarryHeaderIcon';
import { WesIcon } from './WesIcon';
import { WesHeaderIcon } from './WesHeaderIcon';

export function AssistantAvatar({
  mode,
  size = 28,
  pulse = false,
  className = '',
}: {
  mode: AssistantMode;
  size?: number;
  pulse?: boolean;
  className?: string;
}) {
  switch (mode) {
    case 'harry':
      return <HarryIcon size={size} pulse={pulse} className={className} />;
    case 'wes':
      return <WesIcon size={size} pulse={pulse} className={className} />;
    default:
      return <ConciergeHelperIcon size={size} className={className} />;
  }
}

export function AssistantHeaderIcon({
  mode,
  className,
}: {
  mode: AssistantMode;
  className?: string;
}) {
  switch (mode) {
    case 'harry':
      return <HarryHeaderIcon className={className} />;
    case 'wes':
      return <WesHeaderIcon className={className ?? 'h-4 w-4 shrink-0 rounded-full object-cover'} />;
    default:
      return <ConciergeHelperHeaderIcon className={className} />;
  }
}
